import React, {useState} from 'react';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {LoadingOutlined, PlusOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import {Button, Form, message, Upload} from 'antd';
import {RcFile} from 'antd/lib/upload';
import ImgCrop from 'antd-img-crop';
import axios from 'axios';
import {observer} from 'mobx-react-lite';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {INDEX} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {fullUrl} from '../../shared/helpers/fullUrl';

import {
    updateUsersPermissionsUser,
    updateUsersPermissionsUserVariables
} from './__generated__/updateUsersPermissionsUser';
import {MUTATION_UPDATE_USER} from './auth';

export const Avatar = observer(() => {

    const {auth} = useInstance(Store)
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<string|undefined>(auth.data?.avatar ? fullUrl(auth.data?.avatar) : undefined );

    const [update] = useMutation<updateUsersPermissionsUser, updateUsersPermissionsUserVariables>(MUTATION_UPDATE_USER);

    const beforeUpload = (file: RcFile) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('Только файлы в формате JPG и PNG');
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('Изображение должно быть меньше 10Мб');
        }
        return isJpgOrPng && isLt10M;
    };



    const uploadButton = (
        <button style={{backgroundColor: '#F0F0F0', borderRadius: 150, width: 240, height: 240, border: 0}} type="button">
            {loading ? <LoadingOutlined/> : <PlusOutlined/>}
            <div style={{marginTop: 8}}>Загрузить</div>
        </button>
    );


    return (
        <Layout header={<Header title={'Улыбочку'}/>} >
            <Form.Item style={{textAlign:'center'}}>
                <ImgCrop rotationSlider cropShape={'round'}>
                    <Upload
                        // listType="picture-circle"
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        customRequest={async ({file}) => {
                            setLoading(true)
                            const url = fullUrl('/api/upload')
                            const formData = new FormData();
                            formData.append('files', file);
                            axios.post(url, formData, {
                                headers: {
                                    Authorization: `Bearer ${auth.token}`,
                                    'Content-Type': 'multipart/form-data',
                                }
                            }).then(async (res) => {
                                const file = res.data[0]
                                setImageUrl(fullUrl(file.url))
                                await update({
                                    variables: {
                                        id: auth.id!,
                                        data: {
                                            avatar: file.id
                                        }
                                    },
                                    onCompleted: () => {
                                        auth.needUpdate()
                                        setLoading(false)
                                        // navigate(INDEX)
                                    },
                                })
                            })

                        }}
                    >
                        {imageUrl ? <img src={imageUrl} alt="avatar" style={{width: 240, height: 240, borderRadius: 150}}/> : uploadButton}
                    </Upload>
                </ImgCrop>
            </Form.Item>
            <Form.Item>
                <Button type={imageUrl ? 'primary' : 'default'} block onClick={() => navigate(INDEX)}>{imageUrl ? 'Далее' : 'Пропустить'}</Button>
            </Form.Item>
        </Layout>

    )
})